export default __webpack_public_path__ + "static/media/Tabela.f3866038.svg";